import { fetch } from 'libs/fetch';
import { responseInterceptor } from 'views/h5/my-center/features/settlement/helper';
import {
  SettlementDocDetails,
  TraditionalSettlementDocDetails,
} from 'views/h5/my-center/features/settlement/types';
import { downLoadFile } from 'views/h5/my-center/shared/components/AttachmentLink/helper';
export const baseUrl = '/api/tender/v1/purchaser/orderSettlement/mobile/enterprise';
export const traditionalBaseUrl = '/api/tender/v1/purchaser/tradition-settlement';

export const getList = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/searchList', {
      method: 'POST',
      json,
    }),
  );

export const getDetail = (sysNo: string) =>
  responseInterceptor<SettlementDocDetails>(
    fetch(baseUrl + '/get/' + sysNo, {
      method: 'GET',
    }),
  );

export const confirmSettlement = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/confirm', {
      method: 'POST',
      json,
    }),
  );

export const rejectSettlement = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/reject', {
      method: 'POST',
      json,
    }),
  );

export const submitPurchaserSettlement = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/submitSettlement', {
      method: 'POST',
      json,
    }),
  );

export const savePurchaserSettlement = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/save', {
      method: 'POST',
      json,
    }),
  );

export const invalidPurchaserSettlement = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/invalid', {
      method: 'POST',
      json,
    }),
  );

export const invalidPurchaserSettlementTradition = (json: any) =>
  responseInterceptor(
    fetch(traditionalBaseUrl + '/invalid', {
      method: 'POST',
      json,
    }),
  );

// 该方法弃用,使用WEB的能力，在微信环境下无法使用
// @deprecated
export const exportVoucher = async (sysNo: string) =>
  downLoadFile(baseUrl + '/exportVoucher/' + sysNo);

export const getRelationPaymentList = (sysNo: string) =>
  responseInterceptor(
    fetch(baseUrl + '/getRelationPaymentList/' + sysNo, {
      method: 'POST',
    }),
  );

export const getTraditionalDetail = (sysNo: string) =>
  responseInterceptor<TraditionalSettlementDocDetails>(
    fetch(traditionalBaseUrl + '/detail/' + sysNo, {
      method: 'GET',
    }),
  );

export const supplyChainDetail = (id) =>
  responseInterceptor<TraditionalSettlementDocDetails>(
    fetch(`/api/tender/v1/purchaser/contract/supplyChain/detail/${id}`, {
      method: 'GET',
    }),
  );

export const getTraditionalCalcContract = (json: any) =>
  responseInterceptor<any>(
    fetch(traditionalBaseUrl + '/calcContractSettlementTotalAmount', {
      method: 'POST',
      json,
    }),
  );

export const submitYzqSign = (json: any) =>
  responseInterceptor<any>(
    fetch(traditionalBaseUrl + '/submitYzqSign', {
      method: 'POST',
      json,
    }),
  );

export const returnYzqSign = (json: any) =>
  responseInterceptor<any>(
    fetch(traditionalBaseUrl + '/returnYzqSign', {
      method: 'POST',
      json,
    }),
  );

export const markSubmitYzqSignUrge = (json: any) =>
  responseInterceptor<any>(
    fetch(traditionalBaseUrl + '/markSubmitYzqSignUrge', {
      method: 'POST',
      json,
    }),
  );

export const getSettlementSourceList = (json: any) =>
  responseInterceptor(
    fetch('/api/tender/v1/purchaser/orderSettlement/getSettlementSourceList', {
      method: 'POST',
      json,
    }),
  );

export const getPushLogList = (json: any) =>
  responseInterceptor(
    fetch(baseUrl + '/pushLog/queryAll', {
      method: 'POST',
      json,
    }),
  );
